export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_1280kbps-079ee736789b3d38f3ba5b84554cb4b2.avif";